import SolutionPageTemplate from "./SolutionPageTemplate";

const MassagensTerapiasIndividuais = () => (
  <SolutionPageTemplate
    title="Massagens e Terapias Individuais"
    intro={[
      "A Sodalita oferece soluções corporativas de bem-estar por meio de massagens e terapias individuais, promovendo mais saúde, conforto e qualidade de vida no ambiente de trabalho. Os atendimentos são realizados de forma personalizada, respeitando as necessidades de cada colaborador e a realidade de cada empresa.",
      "Investir no cuidado das pessoas contribui para equipes mais engajadas, equilibradas e produtivas.",
    ]}
    benefits={[
      "Redução do estresse e da fadiga no ambiente corporativo",
      "Aumento do bem-estar, foco e produtividade",
      "Alívio de dores e tensões físicas",
      "Atendimento individualizado aos colaboradores",
      "Programas adaptados às necessidades da empresa",
    ]}
    sectionId="massagens-terapias-individuais"
    modifier="solution-page--massagens"
  />
);

export default MassagensTerapiasIndividuais;
